import React, { Component, PropTypes } from 'react';
import { Form, Icon, Table, Button, Modal, Spin, Row, Col, Select, Input, Pagination, DatePicker } from 'antd';

import { Link } from 'react-router';
import _ from 'lodash';
import cn from 'classnames';

// import { formItemLayout } from 'constants/layout';

import { connect } from 'react-redux';
import { editReviewById } from 'data/class';

// import Utils from 'utils/utils';

import moment from 'moment';
import { formatNumber } from 'utils/formatting';
import classes from '../styles/class/ClassInfo.module.scss';
import { formItemLayout } from 'constants/layout';

// const SubMenu = Menu.SubMenu;
// const MenuItemGroup = Menu.ItemGroup;
// const FormItem = Form.Item;
const pageLimit = 20;
const Confirm = Modal.confirm;
const Option = Select.Option;
const { RangePicker } = DatePicker;
const FormItem = Form.Item;
const { TextArea } = Input;

const classTypes = [
  { name: 'กลุ่มเล็ก - เรียนครั้งเดียวจบ', value: 'small-single' },
  { name: 'กลุ่มเล็ก - เรียนหลายครั้ง', value: 'small-multiple' },
  { name: 'กลุ่มเล็ก - ผู้เรียนเสนอตารางเรียน', value: 'small-offering' },
  { name: 'กลุ่มใหญ่ - เรียนครั้งเดียวจบ', value: 'large-single' },
  { name: 'กลุ่มใหญ่ - เรียนหลายครั้ง', value: 'large-multiple' },
];

class ClassReviews extends Component {
  constructor(props) {
    super(props);
    this.onClickRow = this.onClickRow.bind(this);

    this.onDelete = this.onDelete.bind(this);
    this.onSearch = this.onSearch.bind(this);
    // this.onInputSearch = this.onInputSearch.bind(this);
    this.onSearchInputPress = this.onSearchInputPress.bind(this);
    this.changeCategory = this.changeCategory.bind(this);
    this.changeSubcategory = this.changeSubcategory.bind(this);
    this.changeType = this.changeType.bind(this);

    this.onDateChange = this.onDateChange.bind(this);
    this.onUpdateCalendar = this.onUpdateCalendar.bind(this);

    this.onAddNewPageContent = this.onAddNewPageContent.bind(this);
    this.state = {
      collapseMobile: [],
      showModal: false,
      page: props.page,
      isShowRemarkModal: false,
      reviews: [],
      count: 0,
      page: 1,
    };
  }

  componentDidMount = async () => {
    // await this.loadData(1);
  };

  componentWillMount() {
    this.setState({
      showModal: false,
    });
  }
  loadData = async (page = 1) => {
    // this.setState({
    //   loading: false,
    // });
    // const reviews = await getReviewClass(this.props.classroom._id, _.merge(this.getCurrentQuery(), { page }));
    // this.setState({
    //   page: reviews.currentPage,
    //   count: reviews.count,
    //   reviews: reviews.results,
    // });
  };

  onAddNewPageContent() {
    this.setState({
      showModal: true,
      selectedRow: {
        pageName: this.state.selectedStatus,
      },
      isAddNew: true,
    });
  }

  onClickRow(record, index) {
    console.log(record, index);
    // browserHistory.push(`/class/${record.slug}`);
  }

  onChangePage = async (page) => {
    this.props.getReviewClass(_.merge(this.getCurrentQuery(), { page }));
    this.setState({
      page: page,
    });
  };

  onDelete() {}

  onSearch() {
    this.props.getReviewClass(_.merge(this.getCurrentQuery())).then((response) => {
      console.log(response);
    });
    this.setState({
      page: 1,
      searchValue: this.state.displaySearchValue,
    });
  }

  onDateChange(date) {
    this.setState({
      start: date[0],
      end: date[1],
    });
  }

  onTableChange = (a, b, sorter) => {
    console.log('ontable');
    const { field, order } = sorter;
    if (order === 'descend') {
      this.setState({ sortBy: `-${field}` }, this.onSearch);
    } else if (order === 'ascend') {
      this.setState({ sortBy: field }, this.onSearch);
    }
  };

  onSearchInputPress(event) {
    if (event.charCode === 13) {
      this.onSearch();
    }
  }
  onUpdateCalendar(month) {
    this.setState({
      start: moment(),
      end: moment().add(month, 'month'),
    });
  }

  getCurrentQuery() {
    return {
      page: this.state.page,
      sortBy: this.state.sortBy,
      limit: 20,
    };
  }

  changeCategory(category) {
    this.setState({
      selectedCategory: category,
      selectedSubcategory: 'all',
    });
  }

  changeSubcategory(subcategory) {
    this.setState({
      selectedSubcategory: subcategory,
    });
  }

  changeType(event) {
    console.log(event);
  }

  handleSubmit = () => {
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const newReview = { remark: values.remark };
        editReviewById(this.state.selectedReview._id, newReview).then(() => {
          this.props.getReviewClass(this.getCurrentQuery());
          this.setState({
            isShowRemarkModal: false,
          });
          // browserHistory.push('/order');
        });

        console.log('Received values of form: ', values);
      }
    });
  };

  showDeleteConfirm(record, msg, content) {
    Confirm({
      title: msg,
      content: content || '',
      onOk: () => this.onDelete(record),
      onCancel: this.onCancel,
    });
  }

  columns = [
    {
      columnName: 'display',
      title: 'Display',
      dataIndex: 'user.displayName',
      render: (value) => value,
    },
    {
      columnName: 'student',
      title: 'Student Name',
      dataIndex: 'user.name',
      render: (value, record) => (
        <div>
          <Link to={`/student/${record.user._id}`}>{`${value.first} ${value.last}`} </Link>
          {record.user.remark && <Icon type="pushpin" />}
        </div>
      ),
    },
    {
      columnName: 'rating',
      title: 'Rating',
      dataIndex: 'averageRatings',
      sorter: true,
      render: (value) => value,
    },
    {
      columnName: 'date',
      title: 'Date-Time',
      dataIndex: 'createdAt',
      render: (value) => {
        return moment(value).format('DD/MM/YYYY HH:mm');
      },
      sorter: true,
    },
    {
      columnName: 'remark',
      title: 'Remarks',
      dataIndex: 'remark',
      width: 250,
      render: (value, record) => (
        <div>
          {value}{' '}
          <a
            onClick={() => {
              this.setState({
                isShowRemarkModal: true,
                selectedReview: record,
              });
            }}
          >
            <Icon type="edit" />
          </a>
        </div>
      ),
    },
    // {
    //   columnName: 'command',
    //   title: '',
    //   dataIndex: '',
    //   render: (value) => {
    //     return (
    //       <div>
    //         &nbsp;&nbsp;&nbsp;&nbsp;
    //         <Icon type="schedule" className={classes.commandIcon} />
    //       </div>
    //     );
    //   },
    // },
  ];

  renderTotalScore() {
    const { classroom } = this.props;
    return (
      <div>
        <div className={'bold underline'}>คะแนนโดยรวม ({classroom.reviewCount})</div>
        <Row>
          <Col xs={8}>
            <span className={cn('')}>บรรยากาศการเรียนการสอน</span>
          </Col>
          <Col xs={16}>{formatNumber(_.get(classroom, 'ratings.atmosphereRatings'), '0.00')}</Col>
        </Row>
        <Row>
          <Col xs={8}>
            <span className={cn('')}>ทักษะและเทคนิคการสอน</span>
          </Col>
          <Col xs={16}>{formatNumber(_.get(classroom, 'ratings.skillRatings'), '0.00')}</Col>
        </Row>
        <Row>
          <Col xs={8}>
            <span className={cn('')}>เนื้อหาที่สอน</span>
          </Col>
          <Col xs={16}>{formatNumber(_.get(classroom, 'ratings.contentRatings'), '0.00')}</Col>
        </Row>
        <Row>
          <Col xs={8}>
            <span className={cn('')}>เอกสารประกอบ</span>
          </Col>
          <Col xs={16}>{formatNumber(_.get(classroom, 'ratings.documentRatings'), '0.00')}</Col>
        </Row>
      </div>
    );
  }

  renderEditRemarkModal() {
    const { getFieldDecorator } = this.props.form;

    if (!this.state.isShowRemarkModal) {
      return <div />;
    }

    return (
      <Modal
        title={'Edit Remark'}
        visible={this.state.isShowRemarkModal}
        onCancel={() => this.setState({ isShowRemarkModal: false })}
        footer={[
          <Button key="submit" type="primary" size="large" loading={this.state.loading} onClick={this.handleSubmit}>
            Save
          </Button>,
          <Button key="back" size="large" onClick={this.props.handleCancel}>
            Cancel
          </Button>,
        ]}
      >
        <Form onSubmit={this.handleSubmit}>
          <FormItem {...formItemLayout} label="Remark" hasFeedback>
            {getFieldDecorator('remark', {
              initialValue: this.state.selectedReview.remark,
            })(<TextArea />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }

  renderContentTable() {
    const content = _.map(this.props.reviews, (singleContent, key) => {
      singleContent.key = key;
      return singleContent;
    });

    return (
      <div>
        <Table columns={this.columns} dataSource={content} bordered pagination={false} onChange={this.onTableChange} onRowClick={this.onClickRow} />
        <Pagination className={cn(classes.pagination, 'text-right')} current={this.state.page} onChange={this.onChangePage} defaultPageSize={pageLimit} total={this.props.count} />
      </div>
    );
  }

  render() {
    const { schedulesLoading } = this.props;
    console.log(this.props.reviews);
    console.log('RENDER', this.props._reviews);
    if (!this.props.classroom) {
      return <div></div>;
    }
    return (
      <div>
        <Spin tip="Loading" size="large" spinning={!!schedulesLoading}>
          <div className="content">
            <div>{this.renderTotalScore()}</div>
          </div>
          <div className="content">{this.renderContentTable()}</div>
        </Spin>
        {this.renderEditRemarkModal()}
      </div>
    );
  }
}
export default connect(
  (state) => ({}),
  {}, //, activeArticle, recommendArticle, unrecommendArticle, deleteArticle }
)(Form.create()(ClassReviews));
